import { HeartbeatConfiguration } from './HeartbeatConfiguration';
import { createHeartbeatBuilder } from './internal/HeartbeatBuilderImpl';
import { createStreamConcurrencyServiceImpl } from './service/StreamConcurrencyServiceImpl';
import { createHeartbeatServiceImpl } from './service/HeatbeatServiceImpl';
import { StreamConcurrencyService } from './StreamConcurrencyService';
import { HeartbeatManager } from './HeartbeatManager';
import { HeartbeatBuilder } from './HeartbeatBuilder';
import { HeartbeatErrorCodes } from './HeartbeatErrorCodes';
import { OverflowEventMode } from './OverflowMode';
import { HeartbeatService } from './HeartbeatService';
import { HeartbeatResponse, HeartbeatAction } from './model/HeartbeatResponse';
import { PlaybackMode } from './model/PlaybackMode';
import { ProgramInfo } from './internal/model/ProgramInfo';

const version = '__buildVersion__';

export {
  HeartbeatConfiguration,
  createHeartbeatBuilder,
  createStreamConcurrencyServiceImpl as createStreamConcurrencyService,
  createHeartbeatServiceImpl as createHeartbeatService,
  StreamConcurrencyService,
  HeartbeatManager,
  HeartbeatBuilder,
  HeartbeatService,
  HeartbeatErrorCodes,
  OverflowEventMode,
  HeartbeatResponse,
  HeartbeatAction,
  PlaybackMode,
  ProgramInfo,
  version,
};
